var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-form',{staticClass:"mod-form mod-step3",attrs:{"layout":"horizontal","labelAlign":"left","label-col":_vm.labelCol,"wrapper-col":_vm.wrapperCol,"colon":false,"form":_vm.form},on:{"submit":_vm.onSubmit}},[_c('a-form-item',{attrs:{"label":"新密码"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
        'password',
        {
          rules: [
            {
              validator: _vm.handleFieldValidate
            }
          ],
          validateTrigger: 'blur'
        }
      ]),expression:"[\n        'password',\n        {\n          rules: [\n            {\n              validator: handleFieldValidate\n            }\n          ],\n          validateTrigger: 'blur'\n        }\n      ]"}],attrs:{"size":"large","placeholder":"请输入新密码","type":"password"}})],1),_c('a-form-item',{attrs:{"label":"确认新密码"}},[_c('a-input',{directives:[{name:"decorator",rawName:"v-decorator",value:([
        'confirmPassword',
        {
          rules: [
            {
              validator: _vm.handleFieldValidate
            }
          ],
          validateTrigger: 'blur'
        }
      ]),expression:"[\n        'confirmPassword',\n        {\n          rules: [\n            {\n              validator: handleFieldValidate\n            }\n          ],\n          validateTrigger: 'blur'\n        }\n      ]"}],attrs:{"size":"large","placeholder":"请再次输入新密码","type":"password"}})],1),_c('a-form-item',{attrs:{"wrapper-col":_vm.wrapperColOffset}},[_c('a-button',{staticStyle:{"margin":"0","width":"100%"},attrs:{"type":"primary","size":"large","loading":_vm.loading,"html-type":"submit"}},[_vm._v("提交")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }